"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SummarySkeleton = exports.AdditionalLine = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _types = require("../../types");
var _AdditionalInfo = require("../AdditionalInfo");
var _styles = require("../StickyPanel/styles");
var _styles2 = require("../Summary/styles");
var _jsxRuntime = require("react/jsx-runtime");
const PayLine = (0, _mui.styled)(_styles2.Line)((param)=>{
    let { theme } = param;
    return {
        borderTop: "1px solid ".concat((0, _mui.alpha)(theme.palette.grey[900], 0.11)),
        marginTop: theme.spacing(2)
    };
});
const StickyPanelLine = (0, _mui.styled)(_styles2.Line)((param)=>{
    let { theme } = param;
    return {
        justifyContent: 'center',
        gap: theme.spacing(3)
    };
});
const AdditionalLine = exports.AdditionalLine = (0, _mui.styled)(_styles2.Line)((param)=>{
    let { theme } = param;
    return {
        marginBottom: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        borderBottom: "1px solid ".concat((0, _mui.alpha)(theme.palette.grey[900], 0.11)),
        '&:last-child': {
            marginBottom: 0,
            paddingBottom: 0,
            borderBottom: 'none'
        }
    };
});
const PayTextSkeleton = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        width: 80,
        height: 36,
        [theme.breakpoints.up('md')]: {
            width: 90,
            height: 42
        }
    };
});
const CashbackAndBonus = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        paddingTop: theme.spacing(1)
    };
});
const ContinueButton = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        borderRadius: theme.spacing(5),
        marginTop: theme.spacing(3)
    };
});
const DesktopContinueButton = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        borderRadius: theme.spacing(5),
        marginTop: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
            display: 'none'
        }
    };
});
const SummarySkeleton = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles2.Root, {
        "data-testid": getTestId(_types.TestId.SummarySkeleton),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles2.SummaryWrapper, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles2.Line, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                animation: "wave",
                                variant: "text",
                                height: 24,
                                width: 120
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                animation: "wave",
                                variant: "text",
                                height: 24,
                                width: 60
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles2.Line, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                animation: "wave",
                                variant: "text",
                                height: 24,
                                width: 120
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                animation: "wave",
                                variant: "text",
                                height: 24,
                                width: 60
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PayLine, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PayTextSkeleton, {
                                animation: "wave",
                                variant: "text"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PayTextSkeleton, {
                                animation: "wave",
                                variant: "text"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(CashbackAndBonus, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles2.Line, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                        animation: "wave",
                                        variant: "text",
                                        height: 24,
                                        width: 80
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                        animation: "wave",
                                        variant: "text",
                                        height: 24,
                                        width: 60
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles2.Line, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                        animation: "wave",
                                        variant: "text",
                                        height: 24,
                                        width: 90
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                        animation: "wave",
                                        variant: "text",
                                        height: 24,
                                        width: 60
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DesktopContinueButton, {
                        animation: "wave",
                        variant: "rectangular",
                        height: 45,
                        width: "100%"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StickyPanelLine, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                        animation: "wave",
                                        variant: "text",
                                        height: 24,
                                        width: 100
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                        animation: "wave",
                                        variant: "text",
                                        height: 24,
                                        width: 50
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContinueButton, {
                                animation: "wave",
                                variant: "rectangular",
                                height: 45,
                                width: "100%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_AdditionalInfo.Root, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AdditionalLine, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                animation: "wave",
                                variant: "text",
                                height: 24,
                                width: 180
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                animation: "wave",
                                variant: "circular",
                                height: 24,
                                width: 24
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AdditionalLine, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                animation: "wave",
                                variant: "text",
                                height: 24,
                                width: 180
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                animation: "wave",
                                variant: "circular",
                                height: 24,
                                width: 24
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.SummarySkeleton = SummarySkeleton;
